<template>
  <div class="menu-wrapper d-flex black white--text text-center">
    <div
      class="menu-item d-flex flex-column justify-center align-center primary pa-5"
      @click="changeMode('camera')"
    >
      <v-img
        contain
        src="@/assets/menuCamera.svg"
        class="mb-3 menu-icon"
      ></v-img>
      <div class="text-h5 text-sm-h4 font-weight-bold mb-1 mb-sm-3">Camera</div>
      <div class="body-2 body-sm-1">
        {{ $t('cameraDescription') }}
      </div>
    </div>

    <div
      class="menu-item d-flex flex-column justify-center align-center accent pa-5"
      @click="changeMode('presentation')"
    >
      <v-img
        contain
        src="@/assets/menuPresentation.svg"
        class="mb-3 menu-icon"
      ></v-img>
      <div class="text-h5 text-sm-h4 font-weight-bold mb-1 mb-sm-3">{{ $t('program') }}</div>
      <div class="body-2 body-sm-1">
        {{ $t('viewProgram') }}
      </div>
    </div>

    <div
      class="menu-item d-flex flex-column justify-center align-center secondary pa-5"
      @click="changeMode('library')"
    >
      <v-img
        contain
        src="@/assets/menuLibrary.svg"
        class="mb-3 menu-icon"
      ></v-img>
      <div class="text-h5 text-sm-h4 font-weight-bold mb-1 mb-sm-3">{{ $t('library') }}</div>
      <div class="body-2 body-sm-1">
        {{ $t('browseFiles') }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from "vuex";

export default {
  methods: {
    ...mapMutations(["toggleMenu"]),
    changeMode(mode) {
      if (mode == "camera") {
        this.$router.push({ path: "/room/camera" });
      } else {
        this.$router.push({ path: `/room/content/${mode}` });
      }

      this.toggleMenu(false);
    },
  },
};
</script>

<style lang="scss" scoped>
  .menu-wrapper {
    height: 100vh;
  }

  .menu-item {
    flex: 1;
    cursor: pointer;

    img {
      height: 90px;
    }
  }

  .menu-icon {
    width: 90px;
    height: 90px;
    max-height: 90px;
  }

  @media screen and (max-width: 700px) {
    .menu-wrapper {
      flex-direction: column;
    }

    .menu-icon {
      width: 70px;
      height: 70px;
      max-height: 70px;
    }
  }
</style>
